/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'ROLE_VERIFICATION_LOADED',
]);




// WEBPACK FOOTER //
// ./src/constants/RoleVerificationConstants.js